import React, { useEffect, useState } from "react";
import { Chip, TextField, Box } from "@mui/material";

const HighLightCreate = ({ error, helperText, onChange, blur,values }) => {
  const [items, setItems] = useState( values || []);
  const [value, setValue] = useState("");

  const handleKeyDown = (e) => {
    if (e.key !== "Enter") return;

    e.preventDefault();

    const trimmed = value.trim();
    if (!trimmed) return;
    if (items.includes(trimmed)) return;

    setItems((prev) => [...prev, trimmed]);
    setValue("");
  };

  const removeItem = (item) => {
    setItems((prev) => prev.filter((i) => i !== item));
  };

  useEffect(() => {
    onChange(items);
  }, [items]);

  return (
    <Box>
      <TextField
        onBlur={blur}
        label="Enter Project Highlights"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        fullWidth
        size="small"
        error={error}
        helperText={helperText}
      />

      {items.length > 0 && (
        <Box mt={1} display="flex" flexWrap="wrap" gap={1}>
          {items.map((item) => (
            <Chip
              key={item}
              label={item}
              onDelete={() => removeItem(item)}
              color="primary"
              variant="outlined"
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default HighLightCreate;
